module.exports = __webpack_public_path__ + "img/img05.e578d184.svg";